var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow_up",
    "data-name": "arrow up",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.004,
    height: 35.881,
    viewBox: "0 0 28.004 35.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M.75,28H-1V0H.75Z",
    transform: "translate(14.127 7.877)",
    fill: "#dfd9dc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_3-2",
    "data-name": "Line 3",
    d: "M1.75,14.946H0V0H1.75Z",
    transform: "translate(16.042 5.808) rotate(45)",
    fill: "#dfd9dc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line_3-3",
    "data-name": "Line 3",
    d: "M1.75,14.946H0V0H1.75Z",
    transform: "translate(10.725 7.046) rotate(-45)",
    fill: "#dfd9dc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Line_3-4",
    "data-name": "Line 3",
    d: "M1.75,28H0V0H1.75Z",
    transform: "translate(0 1.75) rotate(-90)",
    fill: "#dfd9dc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.d68afaa78ed7cad8c8231c54da22256c.svg";
export { ForwardRef as ReactComponent };